// components/startProject/StartHero.jsx
import "./hero.css";

export default function StartHero() {
  return (
    <section className="sp-hero">
      <div className="sp-hero-container">
        {/* LEFT CONTENT */}
        <div className="sp-hero-left">
          <span className="sp-hero-badge">Start a Project</span>

          <h1>
            Build Your Next <span>Software Product</span> with Oglitz
          </h1>

          <p className="sp-hero-desc">
            Oglitz Software helps startups, growing businesses, and enterprises
            plan, design, and develop scalable, secure, and high-performance
            digital products. From idea validation to launch and long-term
            support — we build software that delivers real business impact.
          </p>

          <ul className="sp-project-points">
            <li>✔ Custom Web, Mobile & Enterprise Software</li>
            <li>✔ Scalable Architecture & Clean Code</li>
            <li>✔ Dedicated Project Manager & Clear Milestones</li>
            <li>✔ NDA, IP Protection & Source Code Ownership</li>
          </ul>

          <div className="sp-location-tags">
            <span>India Delivery Team</span>
            <span>UAE Client Support</span>
          </div>

          <div className="sp-hero-actions">
            <a href="#start-project-form" className="sp-btn-primary">
              Talk to a Project Expert
              <span className="sp-btn-arrow">→</span>
            </a>

            <div className="sp-btn-row">
              <a
                href="https://wa.me/919532119007"
                target="_blank"
                rel="noreferrer"
                className="sp-btn-outline"
              >
                WhatsApp India
              </a>

              <a
                href="https://wa.me/+971568729406"
                target="_blank"
                rel="noreferrer"
                className="sp-btn-outline"
              >
                WhatsApp Dubai
              </a>
            </div>
          </div>

          <p className="sp-alt-contact">
            Prefer email? <a href="/contact">Contact us</a>
          </p>
        </div>

        {/* RIGHT VISUAL */}
        {/* RIGHT VISUAL */}
        <div className="sp-hero-right">
          <div className="sp-project-card">
            <div className="sp-project-header">
              <span className="sp-project-badge">Project Blueprint</span>
              <h3>Your Software Journey</h3>
            </div>

            <ul className="sp-project-steps">
              <li>
                <span>01</span>
                <div>
                  <strong>Idea & Requirements</strong>
                  <p>Understand goals, users & scope</p>
                </div>
              </li>

              <li>
                <span>02</span>
                <div>
                  <strong>UI/UX & Architecture</strong>
                  <p>Design-first, scalable foundation</p>
                </div>
              </li>

              <li>
                <span>03</span>
                <div>
                  <strong>Development & Testing</strong>
                  <p>Agile sprints with quality checks</p>
                </div>
              </li>

              <li>
                <span>04</span>
                <div>
                  <strong>Launch & Scale</strong>
                  <p>Deployment, support & growth</p>
                </div>
              </li>
            </ul>

            <div className="sp-project-footer">
              <span>⚡ Avg. Project Kickoff: 48 Hours</span>
              <span>🔒 NDA & IP Protected</span>
            </div>
          </div>

          {/* Abstract accent */}
          <div className="sp-hero-glow" />
        </div>
      </div>
    </section>
  );
}
